<template>
  <div
    :class="`${widthClass} ${remainingProgressBgClass} relative rounded-full`"
  >
    <div
      :class="`${widthClass} ${progressBgClass} rounded-full transition-[height]`"
      :style="{ height: `${percentageProgressed}%` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  components: {},
  props: {
    percentageProgressed: {
      type: Number,
      required: true,
    },
    widthClass: {
      type: String,
      default: 'w-2',
    },
    progressBgClass: {
      type: String,
      default: 'bg-primary',
    },
    remainingProgressBgClass: {
      type: String,
      default: 'bg-primary-1',
    },
  },
  methods: {},
})
</script>

<style scoped></style>
